import clsx from "clsx";
import { ReactNode } from "react";

import { TruncatedText } from "@/components/Interface/TruncatedText/TruncatedText";

export interface ProductCardHeaderProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  /** e.g. "Wird pausiert am 10.07.2026" — a short status/date line below the subtitle */
  note?: ReactNode;
  /** e.g. one or more <ProductCardChip /> */
  chips?: ReactNode;
  /** Top-right action, e.g. a "Verwalten" button */
  action?: ReactNode;
  className?: string;
}

export const ProductCardHeader = ({
  icon,
  title,
  subtitle,
  note,
  chips,
  action,
  className,
}: ProductCardHeaderProps) => (
  <div
    className={clsx(
      "relative flex h-full w-full flex-col items-start gap-3 pt-4",
      className,
    )}
  >
    {action && <div className="absolute right-0 top-0">{action}</div>}
    <div className="size-14 shrink-0">{icon}</div>
    <div className="flex w-full flex-col gap-1 text-foreground-primary">
      <TruncatedText
        as="h2"
        lines={2}
        text={title}
        className="w-full text-headline-sm font-semibold leading-md"
      />
      {subtitle && (
        <h3 className="truncate text-body-lg leading-md">{subtitle}</h3>
      )}
      {note && <p className="text-body-xs leading-none">{note}</p>}
    </div>
    {chips && (
      <div className="flex w-full flex-wrap items-start gap-2">{chips}</div>
    )}
  </div>
);
